import { PEOPLE_SEARCH_API_PREFIX } from '@aibees/elephant/constants';
import {
  PaginationRequest,
  PaginationResponse,
} from '@aibees/shared/definition';
import { useBaseQuery } from '@aibees/shared/http/hooks';
import { useWorkspace } from '@aibees/shared/workspace';
import { UseQueryOptions } from '@tanstack/react-query';
import {} from '../types';
import { GetPeopleParam, PeopleSearchItem } from './types';

export function useBrowsePeopleApi<T = PeopleSearchItem>(
  params: PaginationRequest<GetPeopleParam>,
  options?: UseQueryOptions<
    PaginationResponse<PeopleSearchItem>,
    any,
    PaginationResponse<T>
  >
) {
  const { page = 0, ...other } = params;

  const workspace = useWorkspace()?.id;

  return useBaseQuery<
    typeof params,
    PaginationResponse<PeopleSearchItem>,
    PaginationResponse<T>
  >(
    [useBrowsePeopleApi.name, page, other],
    {
      url: PEOPLE_SEARCH_API_PREFIX.replace(':wid', String(workspace)),
      params,
      headers: { 'x-customer-id': workspace },
    },
    {
      ...options,
      select: options?.select as (
        data: PaginationResponse<PeopleSearchItem>
      ) => PaginationResponse<T>,
    }
  );
}
